import { FC } from "react";
import svgIcons from "../assets/svg/svgIcons";

export type SortingOptions = {
  label: string,
  value: string,
  disabled?: boolean,
  title?: string,
}

type SortingFilterProps = {
  wrapperClass?: string,
  wrapperPositioningClass?: string,
  showSortingDropdown?: boolean,
  setShowSortingDropdown?: React.Dispatch<React.SetStateAction<boolean>>,
  sortingOptions?: SortingOptions[],
  selectedSorting: string,
  setSelectedSorting: (item: any) => void,
  hasCheckIcon?: boolean,
}

// TODO , maybe make it as general component to use in various place
const SortingFilter: FC<SortingFilterProps> = ({
  wrapperClass = 'absolute mt-2 w-56 divide-y divide-gray-100 rounded-md border border-gray-100 bg-white shadow-lg z-modal',
  wrapperPositioningClass = 'top-0 transform -translate-y-[110%] right-0 md:translate-y-0 md:top-full',
  showSortingDropdown = false,
  setShowSortingDropdown,
  sortingOptions,
  selectedSorting,
  setSelectedSorting,
  hasCheckIcon = true,
}) => {
  return (
    <>
      {showSortingDropdown && (
        <div
          className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
          onClick={() => setShowSortingDropdown && setShowSortingDropdown(false)}
        />
      )}
      <div
        className={`${wrapperClass} ${wrapperPositioningClass}${showSortingDropdown ? "" : " hidden"
          }`}
        role="menu"
      >
        <div className="flex flex-col p-2 space-y-2">
          {sortingOptions?.map((item, index) => (
            <button
              className={`px-3 py-2 space-x-3 flex items-center rounded-lg enabled:hover:bg-accent-blue-paleO66 ${selectedSorting === item.value ? "text-accent-blue-bright" : "text-gray-500 enabled:hover:text-accent-blue-dark disabled:bg-gray-100 disabled:text-gray-400"}`}
              disabled={item?.disabled === true}
              title={item?.title}
              key={index} type="button"
              onClick={() => setSelectedSorting(item.value)}
              role="menuitem">
              {hasCheckIcon && selectedSorting === item.value && (
                <img src={svgIcons.CheckedIcon} alt="checked-icon" />
              )}
              <span className={`block rounded-lg text-sm text-left`}>
                {item.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default SortingFilter;
